import PlannerVehiclesManagerContainer from './PlannerVehiclesManagerContainer';

export default PlannerVehiclesManagerContainer;
